import { render, staticRenderFns } from "./SellingPrices.vue?vue&type=template&id=1cbd2ed2&"
import script from "./SellingPrices.vue?vue&type=script&lang=js&"
export * from "./SellingPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports